import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0366f77c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0366f77c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0366f77c')) {
      api.createRecord('0366f77c', component.options)
    } else {
      api.reload('0366f77c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0366f77c&scoped=true&", function () {
      api.rerender('0366f77c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/config/bonusConfig/index.vue"
export default component.exports